import CheckCircle from '@mui/icons-material/CheckCircle'
import React from 'react'

export default function PaymentSuccessfulByQR({}) {
  return (
    <div
      className="px-3"
      style={{ display: 'flex', justifyContent: 'center', gap: '16px', width: '100%' }}
    >
      <div className="d-flex flex-column gap-1" style={{ fontSize: '20px' }}>
        <div className="d-flex justify-content-center">
          <span className="fw-bold" style={{ fontSize: '2.2em', marginBottom: '10px' }}>
            <CheckCircle sx={{fontSize: 'unset', color: 'green'}} />
          </span>
        </div>
        <div className="d-flex justify-content-center">
          <span className="fw-bold" style={{ fontSize: '1.7em', marginBottom: '10px' }}>
            Payment Successful
          </span>
        </div>
      </div>
    </div>
  )
}
